<template>
  <v-container class="justify-center" fluid>
    <v-row>
      <!-- Avatar Card with Details -->
      <v-col cols="12">
        <v-card elevation="4" class="py-4">
          <v-card-text>
            <v-row>
              <!-- Avatar Section -->
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="180">
                  <v-img v-if="!$store.state.user.picUrl" src="../../assets/profile-pic.png"></v-img>
                  <v-img v-else :src="currentImage" @error="onImageError"></v-img>
                </v-avatar>
                <v-row class="mt-4 flex ga-1" dense>
                  <v-col cols="12">
                    <v-btn @click="showUpdateInfoDialog()" block color="primary" elevation="3" prepend-icon="mdi-account-edit">Update Basic Info</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn @click="showPasswordDialog()" block color="blue" prepend-icon="mdi-account-lock-outline">Update Password</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn @click="showUploadEsignDialog()" block color="orange-darken-1" prepend-icon="mdi-signature-freehand">Upload E-sign</v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Details Section -->
              <v-col cols="12" md="9">
                <v-row>
                  <v-col cols="12">
                    <h3>{{ $store.state.user?.fname }} {{ $store.state.user?.mname ? $store.state.user?.mname[0] + "." : '' }} {{ $store.state.user?.lname }}{{ $store.state.user?.suffix ? ' ' + $store.state.user?.suffix : '' }}{{ $store.state.user?.post_nominal ? ', ' + $store.state.user?.post_nominal : '' }}</h3>
                    <p class="text-grey-darken-1">{{ $store.state.user?.designation ? $store.state.user?.designation : $store.state.user?.position.name  }}</p>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.undergraduate ? $store.state.user?.undergraduate : '----' }}</h3>
                    <p class="text-grey-darken-1">Bachelor's Degree</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.graduate ? $store.state.user?.graduate : '----' }}</h3>
                    <p class="text-grey-darken-1">Master's Degree</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.post_graduate ? $store.state.user?.post_graduate : '----' }}</h3>
                    <p class="text-grey-darken-1">Doctoral/Professional Degree</p>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.academicRank?.description ? $store.state.user?.academicRank?.description : '----'  }}</h3>
                    <p class="text-grey-darken-1">Academic Rank</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.employmentStatus?.description ? $store.state.user?.employmentStatus?.description : '----' }}</h3>
                    <p class="text-grey-darken-1">Employment Status</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.office?.name ? $store.state.user?.office?.name : '----' }}</h3>
                    <p class="text-grey-darken-1">Institute / Office</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.program?.name ? $store.state.user?.program?.name : '----'}}</h3>
                    <p class="text-grey-darken-1">Program</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.designation ? $store.state.user?.designation : '----'}}</h3>
                    <p class="text-grey-darken-1">Designation for Document Signatory</p>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.core_time ? $store.state.user?.core_time : '----' }}</h3>
                    <p class="text-grey-darken-1">Core Time</p>
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3>{{ $store.state.user?.consultation_time ? $store.state.user?.consultation_time : '----' }}</h3>
                    <p class="text-grey-darken-1">Consultation Time</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <UpdateInfoDialog ref="UpdateInfoDialog" @refresh="updateStore"/>
  <UpdatePasswordDialog ref="UpdatePasswordDialog" @logout="logout()" />
  <UploadEsignDialog ref="UploadEsignDialog"/>
</template>

<script>
import UpdateInfoDialog from '../Dialogs/UpdateInfoDialog.vue';
import UpdatePasswordDialog from '../Dialogs/UpdatePasswordDialog.vue';
import UploadEsignDialog from '../Dialogs/UploadEsignDialog.vue';

import { defineComponent } from 'vue';

export default defineComponent({
  components: {
      UpdateInfoDialog,
      UploadEsignDialog,
      UpdatePasswordDialog
  },
  data() {
    return {
      errored: false,
    };
  },
  computed: {
    currentImage() {
      return this.errored || !this.$store.state.user.picUrl
        ? require('@/assets/profile-pic.png')
        : this.$store.state.user.picUrl;
    }
  },
  methods: {
      updateStore(data){
        this.$store.commit('UPDATE_USER', data)
        this.$store.commit('UPDATE_ROLE', data.roles[0])
      },
      showUpdateInfoDialog(){
        this.$refs.UpdateInfoDialog.initUpdate(this.$store.state.user)
      },
      showUploadEsignDialog(){
        this.$refs.UploadEsignDialog.initImage()
      },
      showPasswordDialog(){
        this.$refs.UpdatePasswordDialog.initUpdate()
      },
      logout(){
          localStorage.removeItem("vuex");
          localStorage.removeItem("aums-token");
          window.location.reload()
      },
      onImageError() {
        this.errored = true;
      }
  },

});
</script>

<style scoped>
h3 {
  font-weight: bold;
}
</style>
  